<template>
  <div>
    <v-container class="input-text-size">
      <div id="crud-list-2-0">
        <v-data-table
          dense
          :headers="headers"
          class="elevation-1 input-text-size"
          :items="editedItemArray"
          item-key="key"
          hide-default-footer
          single-expand
          disable-pagination
        >
          <!-- :expanded.sync="expanded" -->
          <template v-slot:top>
          </template>
          <template v-slot:item="{ item, index }">
            <tr @click="toggleExpand(item)">
              <!-- Selection Checkbox - removed, and its header with it (see getHeaders()).
                   It is a leftover from dialogTaxDetails, where the grid is multi-row and the
                   tick drives select-all and the bulk actions. This dialog edits exactly ONE
                   row, so there was nothing to select between: item.selected was read nowhere
                   here, and LargePaymentList.handleTaxDetailChanged deletes it off the item
                   before the update anyway, so ticking it did nothing at all.
              <td class="flex" style="width: 0%;">
                <v-checkbox
                  v-model="item.selected"
                  style="width: 17px;"
                  hide-details
                  dense
                  :disabled="item.posted || item.void"
                  @change="somethingChanged()"
                />
              </td>
              -->
              <!-- Actions - moved up from the end of the row (see getHeaders()). Delete is
                   refused on a row the county has already committed to: posted, voided, or
                   carrying a receipt number. -->
              <td>
                <v-icon
                  small
                  :disabled="item.posted || item.void || !!item.reciept"
                  hide-details
                  dense
                  tabindex="-1"
                  @click="removeOne(item)"
                >
                  {{ icons.mdiDelete }}
                </v-icon>
              </td>
              <!-- AIsVisible Indicator -->
              <td>
                <span v-if="item.AIsVisible" class="ChangeColor">A</span>
              </td>
              <!-- Tax Type -->
              <td>
                <v-select
                  v-model.number="item.taxType"
                  :items="taxType"
                  :rules="reqdTaxTypeValidation"
                  :readonly="isRowLocked(item)"
                  :class="['input-text-size', 'dialog-tax-details-select',
                           { 'readonly-field': isRowLocked(item) }]"
                  id="dialogTaxDetailsSelect"
                  style="width: 80px;"
                  item-text="label"
                  item-value="value"
                  hide-details="auto"
                  dense
                  flat
                  solo
                  @blur="onTypeChange()"
                  @click="onTypeClick()"
                  @change="somethingChanged(), onTypeChange(), handleManualChanges(index, item)"
                />
              </td>
              <!-- Tax Year -->
              <td>
                <v-text-field
                  v-model="item.taxYear"
                  :autofocus="taxYearAutoFocus"
                  :readonly="isTaxKeyLocked(item)"
                  :loading="taxLookupLoading"
                  :class="['dialog-tax-details-tax-year',
                           { 'readonly-field': isTaxKeyLocked(item) }]"
                  id="dialogTaxDetailsTaxYear"
                  hide-details
                  dense
                  flat
                  solo
                  @blur="onTaxKeyBlur(item)"
                  @focus="$event.target.select()"
                />
              </td>
              <!-- Tax ID -->
              <td>
                <v-text-field
                  v-model="item.taxId"
                  ref="taxIdRef"
                  :readonly="isTaxKeyLocked(item)"
                  :loading="taxLookupLoading"
                  :class="['dialog-tax-details-tax-id',
                           { 'readonly-field': isTaxKeyLocked(item) }]"
                  id="dialogTaxDetailsTaxId"
                  style="width: 100px;"
                  hide-details
                  dense
                  flat
                  solo
                  @blur="onTaxKeyBlur(item)"
                />
              </td>
              <!-- Owner Name - display only, readonly not disabled (see .readonly-field) -->
              <td>
                <v-text-field
                  v-model="item.ownerName"
                  class="dialog-tax-details-owner-name readonly-field"
                  id="dialogTaxDetailsOwnerName"
                  style="width: 200px;"
                  hide-details
                  dense
                  readonly
                  flat
                  solo
                />
              </td>
              <!-- Property Tax Type (RE/PP/BP/MH/SA/UT) -->
              <td class="dialog-tax-details-property-tax-type tax-type-col">
                {{ propertyTaxTypeShortCode(item.propertyTaxType) }}
              </td>
              <!-- Receipt / Cert No - shares its header slot, see getHeaders() -->
              <td>
                <v-text-field
                  :value="showCertNumber ? item.certNumber : item.reciept"
                  class="dialog-tax-details-reciept readonly-field"
                  id="dialogTaxDetailsReciept"
                  style="width: 80px;"
                  hide-details
                  dense
                  readonly
                  flat
                  solo
                />
              </td>
              <!-- Tax Amount -->
              <td>
                <v-text-field
                  v-model="item.taxAmt"
                  :class="['dialog-tax-details-tax-amt',
                           { 'readonly-field': isTaxAmtLocked(item) }]"
                  id="dialogTaxDetailsTaxAmt"
                  hide-details
                  dense
                  flat
                  solo
                  @change="handleManualChanges(index, item)"
                  @blur="onAmountBlur(isTaxAmtLocked(item), 'taxAmt')"
                  @focus="onAmountFocus(isTaxAmtLocked(item), 'taxAmt', $event)"
                  :readonly="isTaxAmtLocked(item)"
                />
              </td>
              <!-- Half Payment Checkbox -->
              <td>
                <v-checkbox
                  v-model="item.Half"
                  :disabled="
                    item.posted ||
                    item.void ||
                    item.disableHalf ||
                    // !item.itsNewRecord ||
                    statusForHalf(item.taxAmt)
                  "
                  class="dialog-tax-details-half-checkbox"
                  id="dialogTaxDetailsHalfCheckbox"
                  hide-details
                  dense
                  @change="(val) => isHalfPayment(val)"
                />
              </td>
              <!-- Penalty Amount -->
              <td>
                <v-text-field
                  v-model="item.penaltyAmt"
                  :readonly="isRowLocked(item)"
                  :class="['dialog-tax-details-penalty-amt',
                           { 'readonly-field': isRowLocked(item) }]"
                  id="dialogTaxDetailsPenaltyAmt"
                  hide-details
                  dense
                  flat
                  solo
                  @blur="onAmountBlur(isRowLocked(item), 'penaltyAmt')"
                  @focus="onAmountFocus(isRowLocked(item), 'penaltyAmt', $event)"
                  @change="handleManualChanges(index, item), penaltyChangeManually()"
                />
              </td>
              <!-- Total Fees -->
              <td>
                <v-text-field
                  v-model="item.totalFees"
                  class="dialog-tax-details-total-fees readonly-field"
                  id="dialogTaxDetailsTotalFees"
                  hide-details
                  dense
                  flat
                  solo
                  readonly
                  @blur="onFeesBlur(item, index)"
                >
                  <template v-slot:append>
                    <v-icon
                      small
                      :disabled="item.void"
                      @click="openFeesEditDialog()"
                    >
                      {{ icons.mdiPencil }}
                    </v-icon>
                  </template>
                </v-text-field>
              </td>
              <!-- Total Pay - display only, readonly not disabled (see .readonly-field).
                   The change/focus/blur handlers are dropped rather than carried over: they
                   were unreachable behind `disabled`, and a readonly field DOES fire them, so
                   keeping them would mean merely clicking this cell ran somethingChanged() and
                   marked the payment dirty. Nothing here is editable anyway - calculateTotalDue
                   is what maintains item.total. -->
              <td>
                <v-text-field
                  v-model.number="item.total"
                  class="dialog-tax-details-total readonly-field"
                  id="dialogTaxDetailsTotal"
                  style="width: 85px;"
                  hide-details
                  dense
                  flat
                  solo
                  readonly
                  tabindex="-1"
                />
                <!-- @change="handleManualChanges(index, item)"
                     @focus="amountToNum('total'), $event.target.select()"
                     @blur="somethingChanged(), roundAmount('total')" -->
              </td>
              <!-- Posted -->
              <td class="text-center">
                {{ item.posted ? 'Y' : 'N' }}
              </td>
              <!-- Protest -->
              <td class="text-center">
                {{ item.protest ? 'Y' : 'N' }}
              </td>
              <!-- Void Checkbox -->
              <td class="flex" style="width: 0%;">
                <v-checkbox
                  v-model="item.tempVariableVoid"
                  :disabled="item.posted || item.void"
                  style="width: 17px;"
                  hide-details
                  dense
                  @change="(val) => onVoidChange(val, 0)"
                />
              </td>
              <!-- Actions led the row instead - see the cell after <tr> and getHeaders().
              <td>
                <v-icon
                  small
                  :disabled="item.posted || item.void || !!item.reciept"
                  hide-details
                  dense
                  tabindex="-1"
                  @click="removeOne(item)"
                >
                  {{ icons.mdiDelete }}
                </v-icon>
              </td>
              -->
            </tr>
          </template>

          <template v-slot:expanded-item="{ isOwnerInfoAvailable }">
            {{ isOwnerInfoAvailable }}
            <td
              v-for="item in ownerInfo"
              :key="item._id"
              :colspan="headers.length"
              class="input-text-size blue-font"
            >
              <span>Owner Name: {{ item.name1 }}, </span>
              <span>Tax Due: {{ item.totalDue }}, </span>
              <span>Total paid: {{ item.totalPaid }}, </span>
              <span>Penalty Date:
                {{ item.penaltyStartDate && toShortDate(item.penaltyStartDate) }}
              </span>
            </td>
          </template>
          <template slot="body.append">
            <tr class="sticky-table-footer">
          <!-- <td v-for="(header, index) in headers" :key="index"
          :class="getAlignment(header.value)">
            <strong>
              {{ footerList[index] }}
            </strong>
          </td> -->
        </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>

    <!-- Fee Edit Dialog -->
    <v-dialog
      v-model="editFeesDialog"
      max-width="500"
      class="input-text-size dialog-tax-details-edit-fees"
      id="dialogTaxDetailsEditFees"
    >
      <v-card>
        <v-row justify="space-between" class="px-4">
          <v-card-title class="input-text-size">Edit Fees</v-card-title>
          <v-icon
            @click="addNewFeeRow"
            color="error"
            class="mr-4 mt-4 dialog-tax-details-add-fee-icon"
            id="dialogTaxDetailsAddFeeIcon"
          >
            {{ icons.mdiPlus }}
          </v-icon>
        </v-row>
        <v-card-text class="input-text-size">
          <div id="crud-list-2-0">
            <v-data-table
              :headers="feeHeaders"
              :items-per-page="30"
              :items="feeseditDialog"
              :disabled="!!selTaxDet.posted"
              class="hide-footer-select elevation-1 input-text-size dialog-tax-details-fees-table"
              id="dialogTaxDetailsFeesTable"
              style="max-height: 300px; overflow-y: auto"
              hide-default-footer
              fixed-header
            >
              <template v-slot:[`item.feeNumber`]="{ item, index }">
                <v-select
                  v-model="item.feeNumber"
                  :items="taxFeeMasterData"
                  :item-text="item => `${item.feeNumber} - ${item.feeDescription}`"
                  :disabled="!!selTaxDet.posted"
                  item-value="feeNumber"
                  class="input-text-size dialog-tax-details-fee-select"
                  id="dialogTaxDetailsFeeSelect"
                  dense
                  @change="handleFeeNumberChange($event, index)"
                />
              </template>
              <template v-slot:[`item.feeAmount`]="{ item, index }">
                <v-text-field
                  v-model="item.feeAmount"
                  :disabled="!!selTaxDet.posted"
                  class="input-text-size dialog-tax-details-fee-amount"
                  id="dialogTaxDetailsFeeAmount"
                  dense
                  @blur="roundAmountForFee(item.feeAmount, index)"
                  @focus="amountToNumForFee(item.feeAmount, index), $event.target.select()"
                />
              </template>
              <template v-slot:[`item.actions`]="{ index }">
                <v-icon
                  small
                  @click="removeFeeRow(index)"
                >
                  {{ icons.mdiDelete }}
                </v-icon>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <v-card-actions class="input-text-size dialog-tax-details-edit-fees-actions"
        id="dialogTaxDetailsEditFeesActions">
          <v-btn color="primary" small @click="handleFeesItems(feeseditDialog)"
            :disabled="!!selTaxDet.posted">Save</v-btn>
          <v-btn small @click="closeEditDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// Icon imports
import {
  mdiCircleSlice8,
  mdiDelete,
  mdiPencil,
  mdiPlus,
} from '@mdi/js';

// Vue and Vuex imports
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';

// Component and utility imports
// getFeeListBasedOnEffeciveDate, MIN_ALLOW_AMT_HALF, exemptManufacturingStatusCode,
// getTaxYearStatus and penaltyCalculation moved to taxRowLookup.util with the row math:
// import { getFeeListBasedOnEffeciveDate, getPreviousPenaltyPeriodEnd } from '../../../../components/tax/common-utils/CommonTaxFunctionalities';
// import { MIN_ALLOW_AMT_HALF } from '../../../../components/tax/common-utils/constants';
// import {
//   exemptManufacturingStatusCode, getTaxYearStatus, penaltyCalculation,
// } from '../../../../components/tax/common-utils/tax-common.util';
import { getPreviousPenaltyPeriodEnd } from '../../../../components/tax/common-utils/CommonTaxFunctionalities';
import { buildTaxPaymentTypeOptions } from '../../../../components/tax/common-utils/tax-common.util';
import { applyManualChangesToRow } from '../../../../components/tax/payments/audit/paymentAudit.util';
import { dialogTaxDetailsHeaders } from '../../../../components/tax/payments/paymentutils/PaymentTransactionTableHeaders';
import { authRoles } from '../../../../router/roleGroups';
import { isAuthorised } from '../../../../store/auth/token';
import { toIsoDate, toShortDate, propertyTaxTypeShortCode } from '../../../../util/shared/tmc-global';
import { amountFormat, amountToNumber } from '../../../../util/shared/vue-global';
// the row math this dialog and LargePaymentList's header lookup share
import { buildTaxLookupCriteria, buildTaxRowFromInquiry } from './taxRowLookup.util';

export default {
  name: 'TaxEditDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    baseCrudKey: {
      type: String,
      required: true,
    },
    /**
     * The crud key the payment this row belongs to lives under - passed down by
     * LargePaymentList, which takes it from the payment dialog. Used for the penalty-date
     * precedence below; the default keeps the picklist / existing-payment branches on the key
     * they have always used.
     */
    parentCrudKey: {
      type: String,
      required: false,
      default: 'pickListMakePaymentDialog',
    },
  },

  components: {
    // Add components here if needed
  },
  data() {
    return {
      // Form validation
      valid: false,

      // Table headers. Built through getHeaders() - not straight off the shared list - so the
      // Receipt / Cert No slot honours showCertNumberOnPaymentScreen the way the payment
      // screen's dialogTaxDetails does.
      headers: this.getHeaders(),
      feeHeaders: [
        { text: 'Fee', value: 'feeNumber', align: 'start' },
        { text: 'Amount', value: 'feeAmount' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],

      // Fee editing dialog state
      editFeesDialog: false,
      feeseditDialog: [],
      originalFeesBackup: [], // Backup of original fees for cancel functionality
      selTaxDet: {},
      feeDetailsIndex: 0,

      // Form control state
      taxYearAutoFocus: true,
      // taxType: [], <- moved to a computed, see taxType() below
      // Whether the Type dropdown lists the full descriptions ("1 Tax Payment") or just the
      // numbers ("1"). onTypeClick/onTypeChange flip this; the options build off it.
      showTypeDescriptions: false,

      // Tax Yr / Tax ID lookup state. taxLookupTimerId debounces the two blurs into a single
      // fetch (the clerk usually changes both); lastFetchedKey stops a blur that changed
      // nothing from re-firing the API, mirroring the payment screen's checkObjPaymentsDiff.
      taxLookupTimerId: null,
      taxLookupLoading: false,
      lastFetchedKey: '',
      // Expanded row data
      ownerInfo: [],
      expanded: [],

      // Icons
      icons: {
        mdiDelete,
        mdiPlus,
        mdiPencil,
        mdiCircleSlice8,
      },

      // Validation rules
      rules: {
        required: (v) => !!v || 'This field is required',
        amount: (v) => {
          if (!v) return true; // Allow empty for optional fields
          const num = parseFloat(v);
          return (!Number.isNaN(num) && num >= 0) || 'Must be a valid positive number';
        },
      },
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    ...mapGetters(['todaysDate']),
    ...mapState({
      statusTypes: (state) => state.enums.TaxPaymentEnum || [],
      taxFeeMasterData: (state) => state.shared.taxFeeMaster.taxFeeMasterData || [],
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      halfOrPostmark: (state) => state.tax.taxPayment.halfOrPostmark,
    }),
    showCertNumber() {
      return (this.paymentSettingItem || {}).showCertNumberOnPaymentScreen || false;
    },
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    editedItem: {
      get() {
        const item = this.item(this.baseCrudKey);
        // Initialize fees array if it doesn't exist
        if (item && !item.fees) {
          item.fees = [];
          item.totalFees = '0.00';
        }
        return item;
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    calculateTotal() {
      const taxAmt = parseFloat(this.editedItem.taxAmt) || 0;
      const penaltyAmt = parseFloat(this.editedItem.penaltyAmt) || 0;
      const totalFees = parseFloat(this.editedItem.totalFees) || 0;
      return (taxAmt + penaltyAmt + totalFees).toFixed(2);
    },
    formFields() {
      return this.headers.map((header) => ({
        ...header,
        fieldType: this.getFieldType(header),
        isRequired: this.isRequiredField(header.value),
        isReadonly: header.value === 'total', // Total is calculated
      }));
    },
    editedItemArray() {
      // Convert the editedItem object to an array for v-data-table
      const itemData = this.editedItem;
      // eslint-disable-next-line no-unused-expressions
      if (this.editedItem.void === true) {
        itemData.tempVariableVoid = true;
      }
      itemData.originalTaxAmount = itemData.originalTaxAmount || itemData.taxAmt;
      return itemData && Object.keys(itemData).length > 0 ? [itemData] : [];
    },
    reqdTaxTypeValidation() {
      return [
        (v) => !!v || 'Required',
      ];
    },
    /**
     * Options for the Type dropdown. A computed off statusTypes rather than something
     * onTypeChange() snapshots into data on mount: App.vue fires cacheEnums() without awaiting
     * it, so a dialog mounted before TaxPaymentEnum arrives would snapshot [] and stay empty,
     * nothing rebuilding it when the enum turned up. Narrower window than it sounds, but a
     * computed closes it for free. (The blank Type column reported in Oct 2026 was NOT this -
     * see the :not(.v-select) note in the style block.)
     */
    taxType() {
      // the numbering and the labels are the shared ones (buildTaxPaymentTypeOptions); this
      // dropdown's own trick is swapping the full label for the bare number once the menu shuts
      return buildTaxPaymentTypeOptions(this.statusTypes).map((option) => ({
        ...option,
        label: this.showTypeDescriptions ? option.label : option.short,
      }));
    },
  },
  methods: {
    /**
     * Rewrites the shared Receipt header to Cert No when the county runs with
     * showCertNumberOnPaymentScreen. One slot, relabelled - never both at once. Called from
     * data() (where the setting has not loaded yet, so it falls back to Receipt) and again
     * from the immediate watcher once it has.
     */
    getHeaders(showCert) {
      const useCert = showCert !== undefined
        ? showCert
        : ((this.paymentSettingItem || {}).showCertNumberOnPaymentScreen || false);
      const headers = dialogTaxDetailsHeaders
        // The row-select column is dropped here rather than from the shared list, which
        // dialogTaxDetails still needs it in - that grid is multi-row and selects. See the
        // commented-out cell in the row template.
        .filter((h) => h.value !== 'selected')
        .map((h) => {
          if (h.value === 'reciept') {
            return useCert
              ? { ...h, text: 'Cert No', value: 'certNumber' }
              : h;
          }
          return h;
        });
      // Actions leads the row instead of trailing it: with the select column gone this dialog's
      // one action - delete the row - was stranded off the right-hand end past Void, where the
      // clerk had to scroll the grid sideways to reach it. Reordered here for the same reason
      // the select column is dropped here: dialogTaxDetails renders its own actions cell last,
      // so the shared list has to keep it there.
      const actionsIndex = headers.findIndex((h) => h.value === 'actions');
      if (actionsIndex > 0) headers.unshift(...headers.splice(actionsIndex, 1));
      return headers;
    },
    // Utility functions
    amountFormat,
    amountToNumber,
    toShortDate,
    propertyTaxTypeShortCode,
    ...mapMutations('base/crud', [
      'setItem',
      'setItems',
      'removeItem',
    ]),
    ...mapActions('tax/taxInquires', ['getTaxInquiryForPayment']),
    ...mapActions('tax/taxFee', ['loadTaxRollFeesTable']),
    ...mapActions(['flashWarn']),
    // Essential methods referenced in template
    async onVoidChange(val, index) {
      const currentItem = this.editedItemArray[index];
      if (!currentItem) return;

      if (val) {
        // Store initial values before voiding if not already stored
        if (currentItem.initialTaxAmt === undefined) {
          currentItem.initialTaxAmt = this.amountToNumber(currentItem.taxAmt);
          currentItem.initialPenaltyAmt = this.amountToNumber(currentItem.penaltyAmt);
          currentItem.initialTotalFees = this.amountToNumber(currentItem.totalFees);
          currentItem.initialFees = currentItem.fees || [];
        }

        // Void the item - set amounts to 0 (match dialogTaxDetails exactly)
        currentItem.taxAmt = 0.00;
        currentItem.penaltyAmt = 0.00;
        currentItem.total = 0.00;
        currentItem.fees = [];
        currentItem.totalFees = 0.00;
        // 'isItNewVoidedRecord' will allow us to mitigate compare with previous data in backend
        currentItem.isItNewVoidedRecord = true;
      } else {
        // Restore original values when unvoiding (match dialogTaxDetails exactly)
        const totalCaclAmt = this.amountToNumber(currentItem.initialTotalFees)
          + this.amountToNumber(currentItem.initialTaxAmt)
          + this.amountToNumber(currentItem.initialPenaltyAmt);
        currentItem.total = this.amountFormat(totalCaclAmt || 0);
        currentItem.taxAmt = this.amountFormat(currentItem.initialTaxAmt);
        currentItem.penaltyAmt = this.amountFormat(currentItem.initialPenaltyAmt);
        currentItem.fees = currentItem.initialFees;
        currentItem.totalFees = this.amountFormat(currentItem.initialTotalFees);
        // 'isItNewVoidedRecord' will allow us to mitigate compare with previous data in backend
        currentItem.isItNewVoidedRecord = false;
      }
      this.somethingChanged();
    },
    onTypeClick() {
      // Show full descriptions while the menu is open
      this.showTypeDescriptions = true;
      // this.taxType = this.statusTypes.map((el, index) => ({
      //   label: `${index + 1} ${el.description}`,
      //   value: el.name,
      // }));
    },
    onTypeChange() {
      // Back to the short numeric labels once the menu closes
      this.showTypeDescriptions = false;
      // this.taxType = this.statusTypes.map((el, index) => ({
      //   label: index + 1,
      //   value: el.name,
      // }));
    },
    somethingChanged() {
      // Emit event to parent to handle the update
      this.$emit('dataChanged', this.editedItem);
    },
    checkDisableTax() {
      // eslint-disable-next-line max-len
      const onlyAdminsCanEditTaxAmount = (this.paymentSettingItem || {}).onlyAdminsCanEditTaxAmount || false;
      if (onlyAdminsCanEditTaxAmount && !(isAuthorised(authRoles.SuperAdmin)
       || isAuthorised(authRoles.TaxAdmin))) {
        return true;
      }
      return false;
    },
    /* ------------------------------------------------------------------------------------
     * Lock gates. Each field binds its gate to BOTH `readonly` and the .readonly-field grey
     * instead of to `disabled`, so a locked value stays legible and selectable rather than
     * being painted at Vuetify's 38% opacity and dropped out of the tab order.
     *
     * The catch, and why the handlers below exist: `disabled` swallowed focus and blur, and
     * `readonly` does NOT. Every handler on a lockable field therefore has to no-op when that
     * field is locked. Without it, clicking a posted row's Tax Amt would reformat the value and
     * emit dataChanged - which sets skipNextApiCallForLargePaymentsFlag in the parent and
     * commits the rows, i.e. merely looking at a posted row would mark the payment dirty.
     * ---------------------------------------------------------------------------------- */
    isTaxKeyLocked(item) {
      return !!(item.posted || item.void || !item.itsNewRecord);
    },
    isTaxAmtLocked(item) {
      return !!(this.checkDisableTax() || item.posted || item.void || item.allowBackTaxEdit);
    },
    isRowLocked(item) {
      return !!(item.posted || item.void);
    },
    onTaxKeyBlur(item) {
      if (this.isTaxKeyLocked(item)) return;
      this.somethingChanged();
      this.preUpdateEditedItem();
    },
    onAmountFocus(locked, fieldName, event) {
      if (locked) {
        // still select, so the clerk can copy the figure off a posted row
        event.target.select();
        return;
      }
      this.amountToNum(fieldName);
      event.target.select();
    },
    onAmountBlur(locked, fieldName) {
      if (locked) return;
      this.somethingChanged();
      this.roundAmount(fieldName);
      this.calculateTotalDue();
    },
    onFeesBlur(item, index) {
      if (this.isRowLocked(item)) return;
      this.somethingChanged();
      this.handleManualChanges(index, item);
    },
    /**
     * Handle manual changes to form fields. The body of this moved to
     * applyManualChangesToRow - the Type can now also be changed on the line in the large
     * payment grid, and that path has to settle the row the same way this one does.
     * `index` and `item` are the v-for's, kept so every @change in the template still reads
     * handleManualChanges(index, item); the row edited here is the dialog's single editedItem,
     * which is the same object.
     */
    // eslint-disable-next-line no-unused-vars
    handleManualChanges(index, item) {
      // eslint-disable-next-line max-len
      const taxAmountChangesCreateAudit = (this.paymentSettingItem || {}).taxAmountChangesCreateAudit || false;
      this.editedItem = applyManualChangesToRow({
        row: this.editedItem,
        paymentTransaction: this.item('paymentTransactionList'),
        taxAmountChangesCreateAudit,
      });
      this.somethingChanged();
    },
    /**
     * Tax Yr / Tax ID blur. Debounced by 300ms like the payment screen's postUpdateEditedItem,
     * so changing both fields in one pass costs a single lookup rather than two.
     */
    preUpdateEditedItem() {
      clearTimeout(this.taxLookupTimerId);
      this.taxLookupTimerId = setTimeout(() => {
        this.fetchTaxDetailsForRow();
      }, 300);
    },
    /**
     * Resolves the row's Tax Yr + Tax ID against tax inquiry and repopulates the derived
     * columns - owner, tax amount, penalty, fees, total - the same way the payment screen's
     * commonLoadTaxInquiryFunc does. Only the single row this dialog edits is touched; the
     * batch/popup orchestration around the payment-screen version has no counterpart here.
     */
    async fetchTaxDetailsForRow() {
      const row = this.editedItemArray[0];
      if (!row) return;
      // Matches the Tax Yr / Tax ID field's own :disabled - a posted, voided or already
      // resolved row is not the clerk's to retarget, so nothing should be refetched.
      if (row.posted || row.void || !row.itsNewRecord) return;

      const taxYear = amountToNumber(row.taxYear);
      const taxIdString = (row.taxId === null || row.taxId === undefined)
        ? '' : String(row.taxId).trim();
      if (!taxYear || !taxIdString) return;

      // A blur that changed nothing must not re-hit the API.
      const lookupKey = `${taxYear}-${taxIdString}`;
      if (lookupKey === this.lastFetchedKey) return;

      // Tax ID or parcel ID, decided by length exactly as the payment screen does.
      const criteria = buildTaxLookupCriteria(taxYear, taxIdString);
      if (!criteria) return;

      this.taxLookupLoading = true;
      try {
        const newData = await this.getTaxInquiryForPayment({ criteria });
        if (!(newData || []).length) {
          this.flashWarn('Record with combination of taxyear and taxid not found');
          return;
        }
        this.lastFetchedKey = lookupKey;
        await this.applyTaxInquiryToRow(newData[0]);
      } catch (warn) {
        console.warn('Warning: Something unexpected occurred in fetchTaxDetailsForRow', warn);
      } finally {
        this.taxLookupLoading = false;
      }
    },
    /**
     * The penalty/fee effective date. Same precedence as the payment screen: the parent
     * payment's penalty date if it has one, else today, with Postmark Ok pulling it back a
     * month. The parent lives under its own crud key, hence the two-key lookup.
     */
    getPenaltyEffectiveDate() {
      let penDate = toIsoDate(this.todaysDate);
      const parentPayment = this.item(this.parentCrudKey)
        || this.item('paymentTransactionList') || {};
      if (parentPayment.penaltyDate) {
        penDate = toIsoDate(parentPayment.penaltyDate);
      }
      if ((this.halfOrPostmark || {}).dialogPostmark) {
        penDate = getPreviousPenaltyPeriodEnd(this.todaysDate, this.taxSettingItem.penaltyDate);
      }
      return penDate;
    },
    // The row math is shared with LargePaymentList's header Tax Yr / Tax ID lookup, so it
    // lives in taxRowLookup.util. This keeps the dialog's half-pay carry-over (baseRow.Half)
    // and its own penalty-date precedence.
    async applyTaxInquiryToRow(newData) {
      const updated = await buildTaxRowFromInquiry({
        newData,
        baseRow: this.editedItemArray[0] || {},
        penaltyEffectiveDate: this.getPenaltyEffectiveDate(),
        taxSettingItem: this.taxSettingItem,
        paymentSettingItem: this.paymentSettingItem,
        dialogHalf: (this.halfOrPostmark || {}).dialogHalf,
        loadTaxRollFeesTable: this.loadTaxRollFeesTable,
      });
      this.editedItem = updated;
      this.somethingChanged();
    },
    roundAmount(fieldName) {
      if (this.editedItemArray[0] && this.editedItemArray[0][fieldName]) {
        const value = parseFloat(this.editedItemArray[0][fieldName]);
        if (!Number.isNaN(value)) {
          this.editedItemArray[0][fieldName] = value.toFixed(2);
        }
      }
    },
    calculateTotalDue(index = 0) {
      if (this.editedItemArray[index]) {
        const item = this.editedItemArray[index];
        // Initialize fees array if it doesn't exist
        if (!item.fees) {
          item.fees = [];
          item.totalFees = '0.00';
        }
        const taxAmt = amountToNumber(item.taxAmt) || 0;
        const penaltyAmt = amountToNumber(item.penaltyAmt) || 0;
        const totalFees = amountToNumber(item.totalFees) || 0;
        const totalCaclAmt = penaltyAmt + taxAmt + totalFees;
        item.total = amountToNumber(totalCaclAmt || 0);

        // Calculate change due if total paid is available
        if (item.totalPaid !== undefined) {
          const changeDue = totalCaclAmt - amountToNumber(item.totalPaid);
          item.changeDue = amountFormat(changeDue);
        }

        this.somethingChanged();
      }
    },
    isHalfPayment(val) {
      if (this.editedItemArray[0]) {
        const item = this.editedItemArray[0];
        //  parseFloat(item.originalTaxAmount) || (parseFloat(item.taxAmt) || 0);
        if (val) {
          const taxAmt = amountToNumber(item.totalTax);
          item.taxAmt = (taxAmt / 2).toFixed(2);
        } else {
          const taxAmt = amountToNumber(item.originalTaxAmount);
          item.taxAmt = (taxAmt).toFixed(2);
        }
        this.calculateTotalDue();
      }
    },
    penaltyChangeManually() {
      // Handle manual penalty changes
      this.calculateTotalDue();
    },
    async openFeesEditDialog() {
      const itemData = this.editedItemArray[0];
      if (!itemData) return;

      this.selTaxDet = itemData;
      const itemAmtFormat = [];
      // Create backup of original fees for cancel functionality
      this.originalFeesBackup = JSON.parse(JSON.stringify(itemData.fees || []));
      // formatting to decimals
      for (let i = 0; i < (itemData.fees || []).length; i += 1) {
        const selFeeRec = { ...itemData.fees[i] };
        selFeeRec.feeAmount = amountFormat(selFeeRec.feeAmount);
        // Add feeCreatedAtpayment flag as false for existing fees
        selFeeRec.feeCreatedAtpayment = selFeeRec.feeCreatedAtpayment || false;
        itemAmtFormat.push(selFeeRec);
      }
      this.feeseditDialog = itemAmtFormat;
      this.feeDetailsIndex = 0;
      this.$nextTick(() => {
        this.editFeesDialog = true;
      });
    },
    removeOne(item) {
      // Emit delete event to parent component to handle the deletion
      this.$emit('delete', item);

      // Close the dialog after deletion
      this.close();
    },

    amountToNum(fieldName) {
      // Convert amount field to number for editing
      if (this.editedItemArray[0] && this.editedItemArray[0][fieldName]) {
        const item = this.editedItemArray[0];
        item[fieldName] = this.amountToNumber(item[fieldName]);
      }
    },
    statusForHalf(taxAmt) {
      // Check if half payment should be disabled based on tax amount
      const amount = parseFloat(taxAmt) || 0;
      return amount <= 0;
    },
    close() {
      this.$emit('input', false);
      this.$emit('close');
      this.$nextTick(() => {
        this.editedItem = {};
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
    save() {
      if (this.$refs.form.validate()) {
        // Calculate total before saving
        this.editedItem.total = this.calculateTotal;
        this.$emit('save', this.editedItem);
        this.close();
      }
    },
    getFieldType(header) {
      const { value, formatter } = header;

      // Handle boolean fields (switches)
      if (formatter === 'flagToYorEmpty' || ['posted', 'protest'].includes(value)) {
        return 'switch';
      }

      // Handle amount fields
      if (formatter === 'amount' || ['taxAmt', 'penaltyAmt', 'totalFees', 'total'].includes(value)) {
        return 'amount';
      }

      // Handle number fields
      if (value === 'taxYear') {
        return 'number';
      }

      // Default to text
      return 'text';
    },
    getAlignment(column) {
      // Return alignment based on the column value
      const header = this.headers.find((h) => h.value === column);
      return header && header.align ? `text-${header.align}` : 'text-left';
    },
    isRequiredField(fieldValue) {
      // Define which fields are required
      const requiredFields = ['taxYear', 'taxId', 'ownerName', 'taxAmt'];
      return requiredFields.includes(fieldValue);
    },

    // Fee-related methods
    closeEditDialog() {
      // Restore original fees on cancel
      if (this.originalFeesBackup.length >= 0) {
        const restoredFees = JSON.parse(JSON.stringify(this.originalFeesBackup));
        this.editedItemArray[0].fees = restoredFees;
        // Recalculate totals with original fees
        const totalFees = this.originalFeesBackup.reduce((acc, fee) => (
          acc + amountToNumber(fee.feeAmount)
        ), 0);
        this.editedItemArray[0].totalFees = amountFormat(totalFees);
        this.calculateTotalDue();
        this.somethingChanged();
      }
      this.editFeesDialog = false;
      this.originalFeesBackup = [];
    },

    handleFeesItems(feesItem) {
      // Validate fees before saving
      const invalidFees = feesItem.filter((fee) => !fee.feeNumber || !fee.feeAmount);
      if (invalidFees.length > 0) {
        return;
      }

      // Format fees for saving
      const formattedFees = feesItem.map((fee) => ({
        feeNumber: fee.feeNumber,
        feeDescription: fee.feeDescription,
        feeAmount: amountToNumber(fee.feeAmount),
        feeCreatedAtpayment: fee.feeCreatedAtpayment || false,
        feeMongoId: fee.feeMongoId || null,
      }));

      // Update the current item's fees
      this.editedItemArray[0].fees = formattedFees;

      // Calculate total fees
      const totalFees = feesItem.reduce((acc, item) => acc + amountToNumber(item.feeAmount), 0);
      this.editedItemArray[0].totalFees = amountFormat(totalFees);

      // Create an audit record for any fee that was added, deleted, or changed
      this.handleManualChanges(0, this.editedItemArray[0]);

      // Update totals and close dialog
      this.calculateTotalDue();
      this.selTaxDet = {};
      this.editFeesDialog = false;
      this.originalFeesBackup = [];

      // Emit changes to parent
      this.somethingChanged();
    },

    addNewFeeRow() {
      const newFee = {
        feeNumber: null,
        feeDescription: '',
        feeAmount: 0,
        feeCreatedAtpayment: true,
      };
      this.feeseditDialog = [...this.feeseditDialog, newFee];
      this.updateTotalAfterFeeChange();
    },

    removeFeeRow(index) {
      const fees = [...this.feeseditDialog];
      fees.splice(index, 1);
      this.feeseditDialog = fees;
      this.updateTotalAfterFeeChange();
    },

    updateTotalAfterFeeChange() {
      // Don't update dialogTaxDetails totals during editing
      // This prevents the confusing UX where totals change before save
      // The totals will be updated when handleFeesItems is called on save

      // Only trigger UI updates for visual feedback in the dialog
      this.$forceUpdate();
    },

    handleFeeNumberChange(feeNumber, index) {
      const selectedFee = this.taxFeeMasterData.find((fee) => fee.feeNumber === feeNumber);
      if (selectedFee) {
        const fees = [...this.feeseditDialog];
        fees[index].feeDescription = selectedFee.feeDescription;
        this.feeseditDialog = fees;
      }
    },

    roundAmountForFee(val, index) {
      const curItem = this.feeseditDialog[index];
      curItem.feeAmount = amountFormat(amountToNumber(val));
    },

    amountToNumForFee(val, index) {
      const curItem = this.feeseditDialog[index];
      curItem.feeAmount = amountToNumber(val);
    },

    async toggleExpand(item) {
      // Toggle expansion for owner info display
      if (!item.taxYear || !item.taxId) {
        return;
      }

      // Fires on every row click, so don't re-query a row already resolved - the blur
      // lookup (fetchTaxDetailsForRow) shares lastFetchedKey and has usually filled this in.
      const expandKey = `${amountToNumber(item.taxYear)}-${String(item.taxId).trim()}`;
      if (expandKey === this.lastFetchedKey && this.ownerInfo.length) {
        return;
      }

      // Get owner details from tax inquiry
      const criteria = {
        taxYear: amountToNumber(item.taxYear),
        taxId: amountToNumber(item.taxId),
      };

      try {
        // Call tax inquiry API to get owner details
        const ownerDetails = await this.getTaxInquiryForPayment({ criteria });

        if (ownerDetails && ownerDetails.length > 0) {
          this.ownerInfo = ownerDetails;

          // Update current item with tax inquiry data
          const taxData = ownerDetails[0];
          if (taxData) {
            // Update via editedItem to avoid parameter mutation
            const currentItem = this.editedItemArray[0];
            if (currentItem) {
              currentItem.totalPaid = taxData.totalPaid || 0;
              currentItem.totalTax = taxData.totalTax || 0;
              currentItem.taxTotalDue = taxData.totalDue || 0;
              currentItem.penaltyStartDate = taxData.penaltyStartDate;
              currentItem.baseId = taxData.baseId;
              // NOT currentItem._id - that is the paymenttaxdetails identity, and taxData._id
              // is a taxinquiry id. Overwriting it made a save target the wrong document
              // (harmless only while getTaxInquiryForPayment was a stub returning []).
              currentItem.taxInquiryId = taxData._id;
            }
          }
        }

        // Toggle expansion state
        const isExpanded = this.expanded.includes(item);
        this.expanded = [];
        if (!isExpanded) {
          this.expanded.push(item);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching tax inquiry data:', error);
        this.ownerInfo = [];
      }
    },
  },
  watch: {
    showCertNumber: {
      handler(val) {
        this.headers = this.getHeaders(val);
      },
      immediate: true,
    },
  },
  mounted() {
    // No longer needed: the options are computed and showTypeDescriptions already starts false.
    // // Initialize tax type dropdown with short labels like dialogTaxDetails
    // this.onTypeChange();
    // Seed the lookup key from the row as opened, so simply tabbing through Tax Yr / Tax ID
    // without changing anything does not trigger a pointless refetch.
    const row = this.editedItemArray[0];
    if (row && row.taxYear && (row.taxId !== null && row.taxId !== undefined)) {
      this.lastFetchedKey = `${amountToNumber(row.taxYear)}-${String(row.taxId).trim()}`;
    }
  },
  beforeDestroy() {
    // a pending lookup must not fire after the dialog is gone
    clearTimeout(this.taxLookupTimerId);
  },
};
</script>

<style scoped>
.blue-text {
  text-align: end;
  color: #2196f3 !important;
  padding: 0.5rem;
  border-top: 1px solid rgb(217, 214, 214);
}
.blue-text-left {
  text-align: start;
  color: #2196f3 !important;
  padding: 0.5rem;
  border-top: 1px solid rgb(217, 214, 214);
}

::v-deep .v-data-table-header tr {
  white-space: nowrap;
}
::v-deep .v-list-item__title {
  font-size: 0.75rem;
}
::v-deep .text-center {
  padding: 1px !important;
}
.v-application p {
margin-bottom: 0 !important;
margin-left: 1rem;
}
.blue-font {
  color: #2196f3 !important;
}
::v-deep .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
    min-height: 32px;
}
/* Was `width: 34px`, which pinned EVERY solo input to ~5 characters no matter how wide its
   column actually was - so a 6+ digit receipt or a Total Pay like 1302.42 got cut off even
   though the header text had already reserved the room. Only the fields carrying their own
   inline width (Tax ID, Owner Name) escaped it. 100% lets the input use its column; the 34px
   stays as the floor so a narrow column still renders a usable box.

   :not(.v-select) is load-bearing. A v-select carries .v-text-field too, and its
   .v-select__selections is a `display: flex; flex-wrap: wrap` box holding BOTH the
   .v-select__selection div that prints the chosen value AND a bare input. Giving that input
   width:100% + min-width:34px (over Vuetify's own min-width:0) wrapped it onto a second line
   and pushed the value out of the 32px-tall control - which is how the Type column went blank,
   showing nothing but its arrow. Selects keep Vuetify's sizing. */
/* ::v-deep .v-text-field.v-text-field--solo .v-input__control input {
width: 34px;
} */
::v-deep .v-text-field.v-text-field--solo:not(.v-select) .v-input__control input {
  width: 100%;
  min-width: 34px;
}
.ChangeColor {
  color: red;
}
/* Every non-editable field in the row grid - the always-display-only ones (Owner Name,
   Receipt / Cert No, Fees Total, Total Pay) and the ones locked by posted / void / back-tax /
   admin-only rules (Type, Tax Yr, Tax ID, Tax Amt to Pay, Penalty Amt) - is `readonly` plus
   this grey slot rather than `disabled`. Vuetify paints a disabled input at 38% opacity, which
   is what made these values hard to read, and it drops them out of the tab order so a clerk
   could not click a receipt number or a posted amount to copy it. The grey is what now says
   "not editable"; see the lock-gate methods for the handler guards readonly makes necessary.
   The checkboxes (row select, Half, Void) and the delete icon stay `disabled` - they carry no
   value worth reading, and a greyed background says nothing about a checkbox.
   rgba rather than a flat #eee so this still reads correctly under the dark theme. */
::v-deep .readonly-field.v-text-field--solo > .v-input__control > .v-input__slot {
  background-color: rgba(0, 0, 0, 0.06);
}
</style>
